export class LoanStep1 {
    brandId: string;
    productId: string = "";
    splpgmId: string = "";
    modelId: string;
    variantId: string;
    newQuotFlag : number; // flag to idnetify the type of car selected
    newVehBrandId : string; // selected bank name
    custId: string;
    dealerId: string;
    statusId: string = "";
    indQuotationEntityIdDto: {
        quotationId: string;
        portfolioId: number;
    }

    constructor() {
        this.indQuotationEntityIdDto = {
            quotationId: "",
            portfolioId: 0
        }
    }

}